const ls = require('local-storage');

export class AppAuthToken {

  static STORE_KEY = 'athlete:auth_data';

  constructor() {
    this.authData = null;
  }

  /**
   * ### storeAuthData
   * Store the session key
   */
  storeAuthData(authData) {
    this.authData = authData;
    return ls(AppAuthToken.STORE_KEY, authData);
  }

  loadAuthData() {
      this.authData = ls(AppAuthToken.STORE_KEY);
      return this.authData;
  }

  /**
   * ### getAuthData
   * @param {Object} authData the currentUser object from Parse.com
   *
   * When Hot Loading, the sessionToken  will be passed in, and if so,
   * it needs to be stored on the device.  Remember, the store is a
   * promise so, have to be careful.
   */
  getAuthData() {
    return this.loadAuthData();
  }
  /**
   * ### deleteAuthData
   * Deleted during log out
   */
  deleteAuthData() {
    this.authData = null;
    return ls.remove(AppAuthToken.STORE_KEY);
  }
}

const instance = new AppAuthToken();
export default instance;




// WEBPACK FOOTER //
// ./src/App/Services/AppAuthToken.js